<template>
  <jet-dialog-modal id="quickAddProductModal">
    <template #title>Quick Add Custom Product</template>
    <template #content>
      <div class="row">
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="sku" value="SKU" />
          <jet-input id="sku"  type="text" class="form-control" v-model="form.sku" required/>
          <jet-input-error :message="form.errors.sku" class="mt-2" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="name" value="Name" />
          <jet-input id="name"  type="text" class="form-control" v-model="form.name" />
          <jet-input-error :message="form.errors.name" class="mt-2" />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-6">
          <jet-label class="mb-0" for="user_price" value="Store Price" />
          <jet-input id="user_price"  type="text" class="form-control" v-model="form.user_price" />
          <jet-input-error :message="form.errors.user_price" class="mt-2" />
        </div>
        
      </div>

    </template>

    <template #footer>
      <jet-button icon="fas fa-location-arrow" @click="createProduct">Create</jet-button>
      <jet-danger-button data-dismiss="modal" class="ml-2">Cancel</jet-danger-button>
    </template>
  </jet-dialog-modal>
</template>

<script>
  import JetDangerButton from '@/Jetstream/DangerButton'
  import JetDialogModal from '@/Jetstream/DialogModal'
  import JetInput from '@/Jetstream/Input'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'

  export default {
    emits: ['saveLocation', 'updateLocation', 'beforeSaveLocation'],
    components: {
      JetDangerButton,
      JetDialogModal,
      JetInput,
      JetInputError,
      JetLabel
    },
    props: {
      form: Object,
    },
    data() {
      return {
      }
    },
    methods: {
      hideForm() {
        $('#quickAddProductModal').modal('hide')

          this.form.sku = null
          this.form.name = null
          this.form.user_price = null
      },
      createProduct() {
        // If the method is mtd.locations.update. let the parent component handle the logic
        if (this.updates) {
          this.$emit('updateLocation')
          return
        }

        else {
          // else, handle the success logic and create a callback if the parent needs to do additional data handling
          this.form.post(route('mtd.products.quickadd'), {
          preserveScroll: true,
            onSuccess: () => {
              this.$emit('createProduct', this.form)
              this.hideForm()
            }
          })
        }
      }
    }
  }
</script>
